export class GamerFormData  {
    gamerId: String;
    email: String;
    confirmEmail: String;
  }
